import { PlusOutlined } from "@ant-design/icons";
import { Button, Spin } from "antd";
import Modal from "antd/lib/modal/Modal";
import { useEffect, useState } from "react";
import { Locale } from "../../utils";
import Media from "./Media";

import "./VideoUpload.scss";
const i18n = Locale.getInstance();
const VideoUpload = ({ video, setSelectedVideo, setDeleted }) => {
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [selectedFiles, selectFiles] = useState(false);
  const [selectedVideo, selectVideo] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(true);

  useEffect(() => {
    if (video && video.length > 0) {
      selectVideo(video);
    } else {
      selectVideo([]);
    }
  }, [video]);

  const previewItem =
    selectedVideo && selectedVideo.length > 0 ? selectedVideo[0] : null;
  const previewUrl = previewItem?.url;

  useEffect(() => {
    if (!previewUrl) return;
    setPreviewLoading(true);
    // preload="metadata" often never reaches loadeddata; still guard against stuck UI.
    const maxWait = setTimeout(() => setPreviewLoading(false), 20000);
    return () => clearTimeout(maxWait);
  }, [previewUrl]);

  const handleFinishSelection = () => {
    selectVideo(selectedFiles);
    setSelectedVideo(selectedFiles);
    setOpenUploadModal(false);
  };
  const hideModal = () => {
    setOpenUploadModal(false);
  };

  const showConfirm = () => {
    setOpenUploadModal(true);
  };

  if (previewItem && previewUrl) {
    return (
      <>
        <div className="video-upload">
          <div className="preview preview--with-overlay">
            {previewLoading ? (
              <div className="preview__loading">
                <Spin />
              </div>
            ) : null}
            <video
              key={previewUrl}
              controls
              src={previewUrl}
              preload="auto"
              playsInline
              onLoadedMetadata={() => setPreviewLoading(false)}
              onLoadedData={() => setPreviewLoading(false)}
              onCanPlay={() => setPreviewLoading(false)}
              onError={() => setPreviewLoading(false)}
            />
          </div>
          <div className="remove">
            <Button
              onClick={() => {
                selectVideo([]);
                setDeleted();
              }}
            >
              {i18n.t("common.delete")}
            </Button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="video-upload">
        <div className="upload-button" onClick={showConfirm}>
          <PlusOutlined />
          <div className="ant-upload-text">
            {i18n.t("productEdit.imagesUpload")}
          </div>
        </div>
      </div>

      <Modal
        title={i18n.t("media.selectVideo")}
        open={openUploadModal}
        onOk={handleFinishSelection}
        onCancel={hideModal}
        okText={i18n.t("base.modal.okText")}
        cancelText={i18n.t("base.modal.cancelText")}
        width={880}
      >
        <Media selectFiles={selectFiles} collectionName="videos" />
      </Modal>
    </>
  );
};

export default VideoUpload;
